import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateStreamEntrypointMutation } from "../graphql/mutations";
import type {
  UpdateStreamEntrypointMutationType,
  UpdateStreamEntrypointMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateStreamEntrypointMutation = (
  options?: MutationHookOptions<
    UpdateStreamEntrypointMutationType,
    UpdateStreamEntrypointMutationVariablesType
  >
) => {
  return useMutation<
    UpdateStreamEntrypointMutationType,
    UpdateStreamEntrypointMutationVariablesType
  >(UpdateStreamEntrypointMutation, options);
};
